import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAbout } from "../../actions/aboutActions";
import Loader from "../../components/Loader";
import Meta from "../../components/Meta";
import Message from "../../components/Message";
import "./AboutScreen.css";

const AboutScreen = () => {
  const dispatch = useDispatch();

  const { loading, error, about } = useSelector((state) => state.aboutDetails);

  useEffect(() => {
    dispatch(getAbout());
  }, [dispatch]);

  const image = about?.images?.[0];
  const imageUrl = image?.url || "";

  return (
    <main className="about-newspaper">
      <Meta
        title="About Academy Costumes London | Costume Specialists"
        description="Learn about Academy Costumes London, a specialist costume company working across costume production, bespoke tailoring, vintage textiles and haberdashery."
        image={imageUrl || "/images/home/academy-costumes.png"}
        url="/about"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "About", url: "/about" },
        ]}
      />

      <div className="about-newspaper__inner">
        {loading ? (
          <div className="about-newspaper__state">
            <Loader />
          </div>
        ) : error ? (
          <div className="about-newspaper__state">
            <Message variant="danger">{error}</Message>
          </div>
        ) : (
          <>
            <header className="about-newspaper__masthead">
              <h1 className="about-newspaper__title">
                {about?.title || "About Academy Costumes London"}
              </h1>

              {(about?.intro || about?.subtitle) && (
                <p className="about-newspaper__standfirst">
                  {about?.intro || about?.subtitle}
                </p>
              )}
            </header>

            <article className="about-newspaper__article">
              <div className="about-newspaper__columns">
                <div className="about-newspaper__column about-newspaper__column--lead">
                  <div className="about-newspaper__copy">
                    {about?.leftText || ""}
                  </div>
                </div>

                <div className="about-newspaper__column">
                  <div className="about-newspaper__copy">
                    {about?.rightText || ""}
                  </div>
                </div>
              </div>

              {imageUrl ? (
                <figure className="about-newspaper__figure">
                  <img
                    src={imageUrl}
                    alt={image?.alt || about?.title || "About"}
                    className="about-newspaper__image"
                    loading="lazy"
                    decoding="async"
                  />
                </figure>
              ) : null}
            </article>
          </>
        )}
      </div>
    </main>
  );
};

export default AboutScreen;
